import workerXhr from 'workerXhr';
import settings from '../../settings';

function buildContext(values) {
	return {
		subject: values.subject,
		grade_label: values.program_type === 'grade' ? values.grade_label : null,
		career_name: values.program_type === 'technical_career' ? values.program_name : null,
		course_name: values.program_type === 'course' ? values.program_name : null,
	};
}

// Genera el guion sin encolar el render — se usa para mostrarlo editable en
// un textarea antes de gastar en TTS/Remotion.
export async function previewScript(values) {
	const payload = {
		topic: values.topic,
		program_type: values.program_type,
		context: buildContext(values),
		audience_target: values.audience_target,
	};
	const res = await workerXhr.post('/scripts/preview', payload);
	return res.data;
}

// Encola un job individual en klazia-worker. El callback_url apunta al
// endpoint que klazia-api expone en Fase 4 (worker-callback).
// `scriptOverride` es el guion ya validado/editado por el humano en el paso
// previo (previewScript) — si no se pasa, el worker genera uno nuevo.
export async function createIndividualJob(values, scriptOverride) {
	const payload = {
		mode: 'individual',
		material_id: Number(values.material_id),
		program_type: values.program_type,
		context: buildContext(values),
		topic: values.topic,
		audience_target: values.audience_target,
		script_override: scriptOverride || null,
		metadata: {
			priority: 50,
			callback_url: `${settings.api}/api/worker-callback/videos`,
		},
	};

	const res = await workerXhr.post('/jobs', payload);
	return res.data;
}

export async function getJobStatus(jobId) {
	const res = await workerXhr.get(`/jobs/${jobId}`);
	return res.data;
}
